"use client"
import { useEffect, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import { Box, Typography, CircularProgress, Paper, useTheme } from "@mui/material"
import DiscordIcon from "@mui/icons-material/Chat"

const DiscordCallback = () => {
  const navigate = useNavigate()
  const { login } = useAuth()
  const called = useRef(false)
  const theme = useTheme()

  useEffect(() => {
    if (called.current) return
    called.current = true
    const params = new URLSearchParams(window.location.search)
    const code = params.get("code")
    if (code) {
      login(code).then((success) => {
        if (success) {
          navigate("/profile")
          console.log("nav out succ")
        } else {
          console.log("nav out 1")
          navigate("/")
        }
      })
    } else {
      console.log("nav out 2")
      navigate("/")
    }
  }, [login, navigate])

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 6,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          background: "rgba(13, 15, 25, 0.7)",
          border: "1px solid rgba(0, 229, 255, 0.1)",
          borderRadius: 2,
          maxWidth: "400px",
          width: "100%",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative header */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "4px",
            background: "linear-gradient(90deg, #00e5ff 0%, rgba(0, 229, 255, 0.3) 50%, rgba(0, 0, 0, 0) 100%)",
          }}
        />

        {/* Circuit pattern overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0.05,
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='smallGrid' width='10' height='10' patternUnits='userSpaceOnUse'%3E%3Cpath d='M 10 0 L 0 0 0 10' fill='none' stroke='%2300e5ff' strokeWidth='0.5'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='100%25' height='100%25' fill='url(%23smallGrid)'/%3E%3C/svg%3E\")",
            zIndex: 0,
          }}
        />

        <Box sx={{ position: "relative", zIndex: 1, textAlign: "center" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 3,
              position: "relative",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(0, 229, 255, 0.2) 0%, rgba(0, 0, 0, 0) 70%)",
                animation: "pulse-spotlight 2s infinite ease-in-out",
              }}
            />
            <DiscordIcon
              sx={{
                fontSize: "3rem",
                color: theme.palette.primary.main,
                textShadow: "0 0 10px rgba(0, 229, 255, 0.7)",
              }}
            />
          </Box>

          <CircularProgress
            size={60}
            thickness={4}
            sx={{
              color: theme.palette.primary.main,
              mb: 3,
              "& .MuiCircularProgress-circle": {
                strokeLinecap: "round",
              },
            }}
          />

          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              mb: 1,
              color: theme.palette.primary.main,
              textShadow: "0 0 10px rgba(0, 229, 255, 0.3)",
            }}
          >
            Authenticating
          </Typography>

          <Typography variant="body1" color="text.secondary">
            Completing Discord login...
          </Typography>

          <Box
            sx={{
              mt: 4,
              height: "2px",
              width: "100%",
              background: `linear-gradient(90deg, 
                transparent 0%, 
                ${theme.palette.primary.main} 50%, 
                transparent 100%)`,
              position: "relative",
              "&::after": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-100%",
                right: 0,
                bottom: 0,
                background: `linear-gradient(90deg, 
                  transparent 0%, 
                  ${theme.palette.primary.main} 50%, 
                  transparent 100%)`,
                animation: "loading-bar 1.5s infinite linear",
              },
            }}
          />
        </Box>
      </Paper>

      <style jsx global>{`
        @keyframes pulse-spotlight {
          0% { opacity: 0.5; transform: scale(1); filter: brightness(0.9); }
          50% { opacity: 0.8; transform: scale(1.2); filter: brightness(1.2); }
          100% { opacity: 0.5; transform: scale(1); filter: brightness(0.9); }
        }
        
        @keyframes loading-bar {
          0% { transform: translateX(0%); }
          100% { transform: translateX(200%); }
        }
      `}</style>
    </Box>
  )
}

export default DiscordCallback
